<template>
  <div class="show-alarm-event" >
    <div class="header">
      <el-page-header @back="handleModalCancel" :content="alarmEvent.resourceName + '-' + alarmEvent.eventTypeText +  '-' + alarmEvent.eventSubTypeText  +  '-' + alarmEvent.alarmStateText + '-详情页面'">
      </el-page-header>
    </div>
    <el-row type="flex" class="alarm-event-detail-container">
      <el-col class="chart-container" :span="15">
        <div class="chart-title">告警情况</div>
        <div style="height:calc(65% - 37px);padding-top:20px">
          <ul class="label-value-list">
            <li><span class="label">区域</span><span class="value">{{ getNameById(alarmEvent.regionId, $globalData.regions) }}</span></li>
            <li><span class="label">名称</span><span class="value">{{ alarmEvent.resourceName }}</span></li>
            <li><span class="label">告警状态</span><span class="alarm-value" :class="colorClassFromResourceAlarmState(alarmEvent.resourceKind, alarmEvent.alarmState, alarmEvent.eventType, 1, 0, 0)">
              {{ alarmEvent.alarmStateText }}</span>
            </li>
            <li><span class="label">告警级别</span><span class="value">{{ getNameById(alarmEvent.alarmLevel, $type.alarmLevels) }}</span></li>
            <li><span class="label">数值</span><span class="value">{{ alarmEvent.workStateText }}</span></li>
            <li><span class="label">事件类型</span><span class="value">{{ alarmEvent.eventTypeText }}</span></li>
            <li><span class="label">事件子类型</span><span class="value">{{ alarmEvent.eventSubTypeText }}</span></li>
          </ul>
          <ul class="label-value-list">
            <li><span class="label">事件触发时间</span><span class="value">{{ strDateTimeFromSTime_t(alarmEvent.happenTime) }}</span></li>
            <li><span class="label">正常区间</span><span class="value">{{ alarmEvent.alarmRuleText }}</span></li>
            <li><span class="label">确认状态</span><span class="alarm-value" :class="(alarmEvent.alarmLevel === 0 || alarmEvent.alarmState !== 1 || alarmEvent.handled) ?  'normal-color':'warning-color'">
             {{(alarmEvent.alarmLevel === 0 || alarmEvent.alarmState !== 1) ? '--' : getNameById(alarmEvent.handled, $type.handleStates) }}</span></li>
            <li><span class="label">确认人</span><span class="value">{{ alarmEvent.handled ? getNameById(alarmEvent.handleUserId, $globalData.users) : '--'}}</span></li>
            <li><span class="label">确认时间</span><span class="value">{{ alarmEvent.handled ? strDateTimeFromSTime_t(alarmEvent.handleTime) : '--'}}</span></li>
          </ul>
        </div>
        <div class="chart-title">告警确认</div>
        <div style="height:calc(35% - 37px)">
          <div class="textAreaTitle">确认意见：</div>
          <textarea ref="handleIdeaTextArea" warp="virtual" class="textAreaContent" :value="alarmEvent.handleIdea"></textarea>
          <div style="margin-top: 5px">
            <el-button type="primary" @click="handlePrintTrue" :disabled="alarmEvent.alarmLevel === 0 || alarmEvent.alarmState !== 1 || alarmEvent.handled">实报</el-button>
            <el-button @click="handlePrintFalse" :disabled="alarmEvent.alarmLevel === 0 || alarmEvent.alarmState !== 1 || alarmEvent.handled">误报</el-button>
            <el-button @click="handleClearHandleIdea" :disabled="alarmEvent.alarmLevel === 0 || alarmEvent.alarmState !== 1 || alarmEvent.handled">清空</el-button>
            <el-button @click="handleConfirmAlarm" :disabled="alarmEvent.alarmLevel === 0 || alarmEvent.alarmState !== 1 || alarmEvent.handled">提交</el-button>
            <el-button @click="handleModalCancel">关闭</el-button>
          </div>
        </div>
      </el-col>
      <el-col class="chart-container" :span="9">
<!--        <div class="chart-title">联动控制-->
<!--          <el-pagination-->
<!--            small-->
<!--            @current-change="handleControlNodeTableCurrentPageChange"-->
<!--            :current-page.sync="controlNodeTableQueryParams.pageNum"-->
<!--            :page-size.sync="controlNodeTableQueryParams.pageSize"-->
<!--            layout="total, prev, pager, next"-->
<!--            :total="controlNodeTableTotalRow">-->
<!--          </el-pagination>-->
<!--        </div>-->
<!--        <div style="height:calc(20% - 37px)">-->
<!--          <el-table ref="controlNodeTable"-->
<!--                    :data="controlNodeTableData"-->
<!--                    border highlight-current-row-->
<!--                    style="width: 100%"-->
<!--                    v-loading="loading"-->
<!--                    element-loading-text="努力加载中..."-->
<!--                    element-loading-spinner="el-icon-loading"-->
<!--                    element-loading-background="rgba(255, 255, 255, 0.8)"-->
<!--                    @current-change="handleControlNodeTableCurrentChange">-->
<!--            <el-table-column label="序号" type="index" width="60"></el-table-column>-->
<!--            <el-table-column label="名称" prop="name"></el-table-column>-->
<!--            <el-table-column label="通道号" prop="deviceOutputNum" width="80"></el-table-column>-->
<!--            <el-table-column label="操作" width="130">-->
<!--              <template slot-scope="scope">-->
<!--                <el-button-->
<!--                  class="col-btn"-->
<!--                  type="text"-->
<!--                  @click="handleControlNodeOpen(scope.row)"-->
<!--                >打开-->
<!--                </el-button>-->
<!--                <el-button-->
<!--                  class="col-btn"-->
<!--                  type="text"-->
<!--                  @click="handleControlNodeClose(scope.row)"-->
<!--                >关闭-->
<!--                </el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table>-->
<!--        </div>-->
        <div class="chart-title">联动抓拍
          <el-pagination
            small
            @current-change="handlePictureCurrentPageChange"
            :current-page.sync="picturePageNum"
            :page-size.sync="picturePageSize"
            layout="total, prev, pager, next"
            :total="pictureUrls.length">
          </el-pagination></div>
        <div style="height:calc(50% - 37px)">
          <div class="image-block m5 mt5">
            <el-image :src="pictureUrls[picturePageNum - 1]">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
        <div class="chart-title">{{getCurrentStreamNodeRecordTitle()}}
          <el-button class="video-control-btn" type="primary" :disabled="streamNodes.length === 0" plain @click="handleToggleVideo">{{player.active ? '停止':'实况'}}</el-button>
          <el-button class="video-control-btn" type="primary" :disabled="streamNodes.length === 0" plain @click="handleToggleVideo">{{player.active ? '停止':'回放'}}</el-button>
          <el-pagination
            small
            @current-change="handleStreamNodeCurrentPageChange"
            :current-page.sync="streamNodePageNum"
            :page-size.sync="streamNodePageSize"
            layout="total, prev, pager, next"
            :total="streamNodes.length">
          </el-pagination>
        </div>
        <div style="height:calc(50% - 37px)" class="image-block video-item-content" ref="videoPlayerContainer">
          <!--视频控件-->
          <video id="video-player1" ref="videoPlayer" class="video-player"  v-show="player.active" controls autplayerParamslay style="height: 100%"></video>
          <el-image v-if="!player.active"  style="height: 100%">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
import ShowAlarmEvent from './ShowAlarmEvent.js'
export default ShowAlarmEvent
</script>

<style lang="scss">
  @import "ShowAlarmEvent.scss";
</style>



// WEBPACK FOOTER //
// src/views/common/showAlarmEvent/ShowAlarmEvent.vue